export default __webpack_public_path__ + "static/media/Projects-completed.c736673b.svg";